<template>
    <div class="homeFree">
       <div style="margin-bottom: 15px;">
            <el-select v-model="searchBar.state" clearable placeholder="请选择状态" filterable @change="search(true)">
                <el-option label="已处理" value="1"></el-option>
                <el-option label="未处理" value="0"></el-option>
            </el-select>
            <el-input  placeholder="请输入asin" v-model="searchBar.asin"  style="width:150px;" clearable></el-input>
            <el-input  placeholder="请输入内部SKU" v-model="searchBar.psku"  style="width:150px;" clearable></el-input>
            <el-input  placeholder="请输入电话号码" v-model="searchBar.phone"  style="width:220px;" clearable>
              <el-button slot="append" icon="el-icon-search" @click="search(true)"></el-button>
            </el-input>
       </div>  
       <el-table :data="tableData" style="width: 100%" ref="out-table">
            <el-table-column label="亚马逊订单id" prop="amazonOrderId" width="110"></el-table-column>
            <el-table-column label="客户姓名" prop="userName" width="100"></el-table-column>
            <el-table-column label="客户邮箱" prop="email" width="140"></el-table-column>
            <el-table-column label="客户性别" prop="sex" width="80"></el-table-column>
            <el-table-column label="客户年龄" prop="age" width="80"></el-table-column>
            <el-table-column label="使用时间" prop="productServiceTime" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="选择的原因" prop="cause" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="喜欢程度" prop="likeability" width="120"></el-table-column>
            <el-table-column label="分享程度" prop="shareLevel" width="120"></el-table-column>
            <el-table-column label="评论" prop="remark" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="是否已经处理" prop="state" width="120">
                <template  slot-scope="scope">
                    <div v-if="scope.row.state == 0">未处理</div>
                    <div v-else>已处理</div>
                </template>
            </el-table-column>
            <el-table-column label="卖家sku" prop="msku" width="120"></el-table-column>
            <el-table-column label="内部sku" prop="psku" width="120"></el-table-column>
            <el-table-column label="国家" prop="country" width="120"></el-table-column>
            <el-table-column label="客户地址" prop="address" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="客户电话号码" prop="phone" width="120"></el-table-column>
            <el-table-column label="更新时间" prop="update_date" width="160"></el-table-column>
            <el-table-column label="创建时间" prop="create_date" width="160"></el-table-column>
            <el-table-column label="ASIN" prop="asin" width="120"></el-table-column>
            <el-table-column label="礼品图片链接" prop="img_url" width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    <!-- <a :href="scope.row.img_url">{{scope.row.img_url}}</a> -->
                    <img :src="scope.row.img_url" alt="" style="height:80px;">
                </template>
            </el-table-column>
            <el-table-column label="礼品描述" prop="description" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="备注" prop="notes" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作">
                <!-- <template slot="header">
                    <el-button type="primary" size="mini" @click="AddDialogVisible = true">新增</el-button>
                </template> -->
                <template slot-scope="scope">
                    <el-button size="mini" @click="editGiftDate(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="size"
            :page-sizes="[5, 10, 20,30,50,60,70,100]"
             layout="sizes,prev, pager, next, jumper"
            :total="total">
       </el-pagination>
      <!-- 编辑对话框 -->
      <el-dialog title="编辑" :visible.sync="editDialogVisible" width="35%" center>
        <el-form :model="editForm" :rules="rules" ref="editForm" label-width="auto" class="demo-ruleForm">
            <el-form-item label="亚马逊订单id" prop="amazonOrderId">
                <el-input v-model="editForm.amazonOrderId"></el-input>
            </el-form-item>
             <el-form-item label="备注" prop="notes">
            <el-input type="textarea" v-model="editForm.notes"></el-input>
          </el-form-item>
           <el-form-item label="是否已经处理" prop="state" style="width:100%;">
                <el-select v-model="editForm.state" placeholder="请选择状态">
                    <el-option label="已处理" value="1"></el-option>
                    <el-option label="未处理" value="0"></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="客户姓名" prop="userName">
                <el-input v-model="editForm.userName"></el-input>
            </el-form-item>
            <el-form-item label="客户邮箱" prop="email">
                <el-input v-model="editForm.email"></el-input>
            </el-form-item>
            <el-form-item label="客户性别" prop="sex" style="width:100%;">
                <el-select v-model="editForm.sex" placeholder="请选择性别">
                    <el-option label="Male" value="Male"></el-option>
                    <el-option label="Female" value="Female"></el-option>
                    <el-option label="I don't want to tell you" value="I don't want to tell you"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="客户年龄" prop="age">
                <el-input v-model="editForm.age"></el-input>
            </el-form-item>
            <el-form-item label="使用时间" prop="productServiceTime">
                <el-date-picker v-model="editForm.productServiceTime" type="datetime"  placeholder="选择使用时间"></el-date-picker>
            </el-form-item>
            <el-form-item label="选择的原因" prop="cause">
                <el-input v-model="editForm.cause"></el-input>
            </el-form-item>
             <el-form-item label="分享程度" prop="shareLevel">
                <el-input v-model="editForm.shareLevel"></el-input>
            </el-form-item>
             <el-form-item label="评论" prop="remark">
                <el-input type="textarea" v-model="editForm.remark"></el-input>
            </el-form-item> 
             <el-form-item label="卖家sku" prop="msku">
                <el-input v-model="editForm.msku"></el-input>
            </el-form-item>
             <el-form-item label="内部sku" prop="psku">
                <el-input v-model="editForm.psku"></el-input>
            </el-form-item>
            <el-form-item label="国家" prop="country">
                <el-input v-model="editForm.country"></el-input>
            </el-form-item>
            <el-form-item label="客户地址" prop="address">
                <el-input type="textarea" v-model="editForm.address"></el-input>
            </el-form-item>
             <el-form-item label="客户电话号码" prop="phone">
                <el-input v-model="editForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="ASIN" prop="asin">
                <el-input v-model="editForm.asin"></el-input>
            </el-form-item>
           <el-form-item label="礼品图片:" prop="img_url" ref="img_url" >
                <el-upload
                    action="#"
                    list-type="picture-card"
                    :http-request="editUploadFile"
                    :limit="1"
                    :file-list="fileList"
                    :on-exceed="editHandleExceed"
                    :on-remove="editHandleRemove">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="editForm.img_url" alt="">
                </el-dialog>
           </el-form-item>
          <el-form-item label="礼品描述" prop="description">
            <el-input type="textarea" v-model="editForm.description"></el-input>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitFormEdit('editForm')">确定</el-button>
            <el-button @click="resetFormEdit('editForm')">取消</el-button>
        </span>
      </el-dialog>
    </div>
</template>
<script>
// 
import{autoLoginFreeGiftList,editAutoLoginFreeGift} from '../../api/homeAutoLoginFreeGift'
// import {giftUploadPictures,giftDeletePictures} from '../../api/homeFreeGift'
export default {
    data() {
        // 邮箱验证
        var email = (rule, value, callback) => {
            // 邮箱正则
            const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
            // 邮箱框value判断
            if (!value) {
                callback(new Error('邮箱不能为空'))
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的邮件格式'))
            } else {
                callback()
            }
        }
        return {
            tableData:[],
            page:1,
            size:10,
            total:10,
            searchBar:{
                state:'',
                asin:'',
                psku:'',
                phone:''
            },
            editDialogVisible:false,
            editForm:{},
            labelPosition: "right",
            rules:{
                amazonOrderId: [{ required: true, message: '请输入亚马逊订单id', trigger: 'blur' }],
                userName: [{ required: true, message: '请输入客户姓名', trigger: 'blur' }],
                email: [{required: true, validator: email, trigger: 'blur' }],
                sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
                age: [{ required: true, message: '请输入客户年龄', trigger: 'blur' }],
                productServiceTime: [{ type: 'date', required: true, message: '请选择使用时间', trigger: 'change' }],
                cause: [{ required: true, message: '请输入选择的原因', trigger: 'blur' }],
                likeability: [{ required: true, message: '请输入喜欢程度', trigger: 'blur' }],
                shareLevel: [{ required: true, message: '请输入分享程度', trigger: 'blur' }],
                remark: [ { required: true, message: '请填写评论', trigger: 'blur' }],
                state: [{ required: true, message: '请选择状态', trigger: 'change' }],
                msku: [ { required: true, message: '请输入卖家sku', trigger: 'blur' }],
                psku: [ { required: true, message: '请输入内部sku', trigger: 'blur' }],
                country: [ { required: true, message: '请输入国家', trigger: 'blur' }],
                address: [ { required: true, message: '请填写客户地址', trigger: 'blur' }],
                phone: [ { required: true, message: '请输入电话号码', trigger: 'blur' }],
                update_date: [{ type: 'date', required: true, message: '请选择更新时间', trigger: 'change' }],
                create_date: [{ type: 'date', required: true, message: '请选择创建时间', trigger: 'change' }],
                asin: [ { required: true, message: '请输入asin', trigger: 'blur' }],
                gift_sku: [{ required: true, message: '请输入礼品SKU', trigger: 'blur' }],
                notes: [{ required: true, message: '请填写备注', trigger: 'blur' }]
            },
        }
    },
    methods:{
        // 分页选择条数触发
        handleSizeChange(size) {
            this.size = size;
            this.search(false);
        },
        // 分页选择页面触发
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.search(false);
        },
        // //  多条件搜索
        // getSearchDate(){
        //     for (const key in this.searchBar) {
        //         if(this.searchBar[key] == '' || this.searchBar[key] == undefined){
        //             delete this.searchBar[key]
        //         }
        //     }
        //     autoLoginFreeGiftList({page:this.page,size:this.size,q:this.searchBar}).then((res=>{
        //         if (res.data.code === 200){
        //             this.tableData = res.data.data.content;
        //             this.total = res.data.data.total_elements;
        //         }
        //     }))
        // },
        // 查询
        search(boolean){
          this.searchBar = this.common.clearNull(this.searchBar);
          this.page = boolean ? 1 : this.page;
            autoLoginFreeGiftList({page:this.page
              ,size:this.size
              ,q:JSON.stringify(this.searchBar)
              ,sort: "amazonOrderId",
              direction: "DESC"
            }).then((res=>{
                if (res.data.code === 200){
                  if (boolean) {
                    this.$message.success(res.data.message);
                  }
                    this.tableData = res.data.data.content;
                    this.total = res.data.data.total_elements;
                }
            }))
        },
        // // 列表
        // getGiftList(){
        //     autoLoginFreeGiftList({page:this.page,size:this.size}).then((res=>{
        //         if (res.data.code === 200){
        //             this.tableData = res.data.data.content;
        //             this.total = res.data.data.total_elements;
        //         }
        //     }))
        // },
        // 编辑
        editGiftDate(row){
            this.editForm = JSON.parse(JSON.stringify(row));
            this.editDialogVisible = true;
        },
        submitFormEdit(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    editAutoLoginFreeGift({id:this.editForm.id,data:this.editForm}).then((res=>{
                        if(res.data.code == 200){
                             this.$message.success(res.data.message);
                            this.$refs[formName].resetFields();
                            this.editDialogVisible = false;
                             this.search(false);
                         }else{
                             this.$message(res.data.message)
                         }
                    }))
                } else {
                    return false;
                }
            });
        },
        // 关闭弹框
        resetFormEdit(formName) {
            this.editDialogVisible = false;
            this.$refs[formName].resetFields();
        },
    },
    created(){
      this.search(true)
    }
}
</script>
<style lang="less" scoped>
.homeFree {
     padding: 50px 30px;
  .el-select .el-input {
    width: 150px;
  }
}
.el-input-group {
  // margin-left: 30px;
  width: 500px;
}
// .el-table {
//   padding: 50px 30px;
// }
.el-pagination {
    padding: 32px 0px;
}
.el-select>.el-input {
    width: 80% !important;
}

</style>